var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { isEqual } from 'lodash';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Level } from '@/models/Level';
let LevelSelect = class LevelSelect extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.defaultFilters = {
            depth: 0,
        };
        this.levels = [];
        this.isLoading = true;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchLevels();
        this.isLoading = false;
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods
    async fetchLevels() {
        this.levels = await new Level()
            .include(this.includes || [])
            .filter(this.mergedFilters)
            .all();
    }
    async onInput(value) {
        if (isEqual(this.value, value)) {
            return;
        }
        this.$emit('input', value);
    }
    // #endregion
    // #region Getters & Setters
    get mergedFilters() {
        return this.filters
            ? { ...this.filters, ...this.defaultFilters }
            : this.defaultFilters;
    }
    // #endregion
    // #region @Watchers
    onPropChange(newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        this.fetchLevels();
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], LevelSelect.prototype, "value", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", Array)
], LevelSelect.prototype, "includes", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], LevelSelect.prototype, "filters", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], LevelSelect.prototype, "useMorePadding", void 0);
__decorate([
    Watch('includes', { immediate: true, deep: true }),
    Watch('filters', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], LevelSelect.prototype, "onPropChange", null);
LevelSelect = __decorate([
    Component({
        components: {
        //
        },
    })
], LevelSelect);
export default LevelSelect;
